<template>
  <div class="export-job-container">
    <h3
      class="m-b-5 export-job-name"
      :title="job.name"
    >
      {{ job.name }}
    </h3>

    <div v-if="isJobPending">
      <div class="uiv text-nowrap m-b-0">
        <progress-bar
          v-model="progressState"
          type="success"          
          class="m-b-0"
          label
          :active="isProgressIndefinite"
          :striped="isProgressIndefinite"
          :label-text="progressFullDescription"
        />
      </div>
    </div>
    <div v-if="isJobReady">
      <button
        class="toast-close-button"
        type="button"
        @click="dismissJob"
      >
        <span v-t="'X'" />
      </button>
      <div>
        <a
          :href="jobStatus.url"
          :target="aHrefDownloadTarget"
          download
        >
          <i class="fa fa-download m-r-5" />
          {{ jobDownloadTitle }}
        </a>
      </div>
    </div>
    <div v-if="isJobError">
      <button
        class="toast-close-button"
        type="button"
        @click="dismissJob"
      >
        <span v-t="'X'" />
      </button>
      <div>
        <strong><i class="fa fa-exclamation-triangle m-r-5" /> <span v-t="'ERROR_PLEASE_TRY_AGAIN'" /></strong>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import messages from './locales';

export default {

  name: 'ExportJobItem',

  props: {
    job: {
      type: Object,
      default: null
    },
  },

  computed: {
    ...mapState('exportFiles', [
      'exportJobsStatus',
    ]),

    jobStatus() {
      return this.exportJobsStatus.find(w => w.id == this.job.id);
    },

    isJobError() {
      return this.jobStatus?.status === 'Error';
    },

    isJobReady() {
      return this.jobStatus?.status === 'Ready';
    },

    isJobPending() {
      return this.jobStatus?.status === 'Pending' ?? true;
    },

    jobDownloadTitle() {
      return this.job?.downloadTitle ?? this.$t('DOWNLOAD_REPORT');
    },

    aHrefDownloadTarget() {
      const defaultTarget = '_self';
      const newTabExtensions = ['pdf']; 
      
      try {
        const url = new URL(this.jobStatus.url);
        const pathname = url.pathname;
        const fileExtension = pathname.split('.').pop().toLowerCase();
        
        return newTabExtensions.includes(fileExtension) ? '_blank' : defaultTarget;
      } catch {
        return defaultTarget;
      }
    },

    isProgressIndefinite() {
      return this.job?.isProgressIndefinite ?? false;
    },

    progressState() {
      if (this.isProgressIndefinite) {
        return 100;
      }

      return this.jobStatus?.progressPercent > 0 ? this.jobStatus?.progressPercent : 0;
    },

    progressPercent() {
      return `${this.progressState}%`; 
    },

    progressStateDescription() {
      if (!this.jobStatus) {
        return '';
      }
      
      return `(${this.jobStatus?.progressStage || this.$t('EXPORTING')})`; 
    },

    progressFullDescription() {
      if (this.isProgressIndefinite) {
        return this.progressStateDescription;
      }

      return `${this.progressPercent} ${this.progressStateDescription}`;
    },

  },

  methods: {
    ...mapActions('exportFiles', [
      'dismissAndClearJob'
    ]),

    dismissJob() {
      this.dismissAndClearJob(this.job.id);
    }
  },

  i18n: {
    messages,
    locale: 'en'
  }
};
</script>

<style>

</style>